"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnIntegAw = void 0;
const base_1 = require("./base");
const aw_1 = require("../services/aw");
/**
 * AdWords
 */
class AnIntegAw extends base_1.AnIntegBase {
    static isLoaded() {
        return aw_1.AnServAw.isLoaded();
    }
    static sendInit(siteCategory, userId, email, coupon) {
        aw_1.AnServAw.sendInit(this.getPixelId(siteCategory), null, null, null);
        return true;
    }
    static sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon) {
        //
        // * Account: Five Four MCC > Five Four
        // * Conversion Name: Purchase Completion
        // * Conversion Label: s9c5COOXrRIQrfrn0AM
        //
        aw_1.AnServAw.sendTrackConversion(this.getPixelId(siteCategory), "s9c5COOXrRIQrfrn0AM", price);
        return true;
    }
    static sendTrackClubThankyouLegacy(siteCategory, userId, email, price, style, color, coupon) {
        return this.sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon);
    }
    static sendTrackClubRejoinLegacy(siteCategory, userId, email, price) {
        //
        // * Account: Five Four MCC > Five Four
        // * Conversion Name: Winback Conversion
        // * Conversion Label: kL8tCL71pHwQrfrn0AM
        //
        aw_1.AnServAw.sendTrackConversion(this.getPixelId(siteCategory), "kL8tCL71pHwQrfrn0AM", price);
        return true;
    }
    static sendTrackEcommThankyou(siteCategory, userId, orderId, price, coupon) {
        //
        // * Account: Five Four MCC > Five Four
        // * Conversion Name: Ecomm Conversion
        // * Conversion Label: ioSJCMDJ-GwQrfrn0AM
        //
        aw_1.AnServAw.sendTrackConversion(this.getPixelId(siteCategory), "ioSJCMDJ-GwQrfrn0AM", price, orderId);
        return true;
    }
    static sendTrackQuizStartLegacy(siteCategory) {
        return this.sendTrackQuizStart(siteCategory);
    }
    static sendTrackQuizStart(siteCategory) {
        //
        // * Account: Five Four MCC > Five Four
        // * Conversion Name: Menlo House- Quiz Start
        // * Conversion Label: qavNCJ_rhn8Qrfrn0AM
        //
        aw_1.AnServAw.sendTrackConversion(this.getPixelId(siteCategory), "qavNCJ_rhn8Qrfrn0AM");
        return true;
    }
    static sendTrackEcommAccountCreate(siteCategory, userId, email) {
        return this.sendTrackClubAccountCreate(siteCategory, userId, email);
    }
    static sendTrackClubAccountCreate(siteCategory, userId, email) {
        //
        // * Account: Five Four MCC > Five Four
        // * Conversion Name: Menlo House- Account Creation
        // * Conversion Label: LAe7CIacnX8Qrfrn0AM
        //
        aw_1.AnServAw.sendTrackConversion(this.getPixelId(siteCategory), "LAe7CIacnX8Qrfrn0AM");
        return true;
    }
    static sendTrackClubAccountCreateLegacy(siteCategory, userId, email) {
        return this.sendTrackClubAccountCreate(siteCategory, userId, email);
    }
    static sendTrackEcommProductAddToCart(siteCategory, productId) {
        //
        // * Account: Five Four MCC > Five Four
        // * Conversion Name: Menlo House- Add to Cart
        // * Conversion Label: hgt5CJmson8Qrfrn0AM
        //
        aw_1.AnServAw.sendTrackConversion(this.getPixelId(siteCategory), "hgt5CJmson8Qrfrn0AM");
        return true;
    }
}
exports.AnIntegAw = AnIntegAw;
AnIntegAw.shouldSendTrackClubThankyou = true;
AnIntegAw.shouldSendTrackClubThankyouLegacy = true;
AnIntegAw.shouldSendTrackClubRejoinLegacy = false;
AnIntegAw.shouldSendTrackQuizStart = true;
AnIntegAw.shouldSendTrackEcommAccountCreate = false;
AnIntegAw.shouldSendTrackClubAccountCreate = true;
AnIntegAw.shouldSendTrackClubAccountCreateLegacy = true;
AnIntegAw.shouldSendTrackEcommThankyou = true;
AnIntegAw.shouldSendTrackEcommProductAddToCart = true;
AnIntegAw.pixelId = {
    prod: {
        defaultId: "AW-974781741",
        ecomm: null,
        club: null,
    },
    dev: {
        defaultId: "AW-974781741",
        ecomm: null,
        club: null,
    },
};
